module.exports = __webpack_public_path__ + "media/images/light/logo/logo-square-bg-15b8162e6744af295cb6ff81823550b7.png";